if (!customElements.get('checkout-action')) {
    class CheckoutAction extends HTMLElement {

        constructor() {
            super();
            this._loading = false;
            this.submit = this.querySelector('button');
        }

        get loading() { return this._loading; }

        set loading(value) {
            if (this._loading == value) return;
            this._loading = value;
            this.submit.disabled = value;
            this.submit.setAttribute('aria-disabled', `${value}`);
            this.submit.classList.toggle('is-loading');
            document.body.classList.toggle('checkout-loading');
        }

        connectedCallback() {
            this.submit.addEventListener('click', this.handleSubmit.bind(this));
            document.addEventListener('request:loading:start', this.requestLoadingStart.bind(this));
            document.addEventListener('request:loading:end', this.requestLoadingEnd.bind(this));
        }

        disconnectedCallback() {
            this.submit.removeEventListener('click', this.handleSubmit.bind(this));
            document.removeEventListener('request:loading:start', this.requestLoadingStart.bind(this));
            document.removeEventListener('request:loading:end', this.requestLoadingEnd.bind(this));
        }

        requestLoadingStart() {
            this.loading = true;
        }

        requestLoadingEnd() {
            this.loading = false;
        }

        async handleSubmit(e) {

            // Start loading
            document.dispatchEvent(new CustomEvent('request:loading:start', { bubbles: true}));

            document.querySelectorAll(`.cart-items tr`).forEach((row) => row.classList.remove('selected'));
            
            // const storedItems = JSON.parse(document.querySelector('[data-cart-items]').innerText);
            // const alternatives = storedItems.filter(({ quantity, properties }) => {
            //     const isHidden = Object.keys(properties).includes('_hidden');
            //     // const hasErrors = Object.keys(properties).includes('_answer_type');
            //     const isAlternative = Object.keys(properties).includes('_is_alternative_product');
            //     const unresolved = properties._resolved != true;
            //     const adjusted = Object.keys(properties).includes('_original_qty') ? parseInt(properties._original_qty) != quantity : false;
            //     return /*!hasErrors &&*/ isAlternative && unresolved && !adjusted && !isHidden;
            // });

            const { items } = LocalCart.getState();
            const alternatives = items.filter(({ quantity, properties }) => {
                const isHidden = Object.keys(properties).includes('_hidden');
                const isAlternative = Object.keys(properties).includes('_is_alternative_product');
                const unresolved = properties._resolved != true;
                const adjusted = Object.keys(properties).includes('_original_qty') ? parseInt(properties._original_qty) != quantity : false;
                return isAlternative && unresolved && !adjusted && !isHidden;
            });

            console.log(`Alternatives products (From component-checkout-action.js) >>`,alternatives);
            alternatives.length ? await window.checkout.handleStockLevelCheck() : await window.checkout.handleApprove();

            // End loading
            document.dispatchEvent(new CustomEvent('request:loading:end', {bubbles: true}));

        }
    }

    customElements.define('checkout-action', CheckoutAction);
}